

import { View, Text, StyleSheet, TouchableOpacity, ScrollView, Button, Image, Platform, Modal, ActivityIndicator, PixelRatio, Dimensions } from 'react-native'
import React, { useEffect, useState } from 'react'
import { useRoute } from '@react-navigation/native'
import { TextInput } from 'react-native'
import Colours from '../../utils/Colours'
import axios from '../../api/axios'
import { useNavigation } from '@react-navigation/native'
import { useQuery } from '@tanstack/react-query'
import BackArrow from '../../icons/BackArrow'
import ErrorAlertComp from '../../alertComp/ErrorAlertComp'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import SuccessAlertComp from '../../alertComp/SuccessAlertComp'
import PasswordIcon from '../../icons/PasswordIcon'
import EmailIcon2 from '../../icons/EmailIcon2'
import EmailIcon from '../../icons/EmailIcon'
import AppTextInput from '../../utils/ColourThemes/AppTextInput'


const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const NewPasswordSettings = ({ email, resetCode, hideModal, setShowEmailEntry, setIsVerifyEmailCodeVisible, setNewPasswordSettingsVisible }) => {

    const [successMessasge, setSuccessMessage] = useState('')
    const [isSuccessCompVisible, setIsSuccessCompVisible] = useState(false)
    const [errorMessage, setErrorMessage] = useState('');
    const [isErrorCompVisible, setIsErrorCompVisible] = useState(false)
    const [isPasswordFocused, setIsPasswordFocused] = useState(false);
    const [isPassword2Focused, setIsPassword2Focused] = useState(false)
    const [password, setPassword] = useState('')
    const [password2, setPassword2] = useState('')


    const [suggestions, setSuggestions] = useState([]);
    const [strength, setStrength] = useState('');

    const [isLoading, setIsLoading] = useState(false)
    const [buttonActive, setButtonActive] = useState(false)

    const navigate = useNavigation()

    const handlePassword = (text) => {
        setPassword(text)
        //console.log('PASSWORDTXT', text)
        validatePassword(text)
    }

    const handle2Password = (text) => {
        setPassword2(text)
        //console.log('PASSWORD2', text)
    }

    const validatePassword = (input) => {
        let newSuggestions = [];
        if (input.length < 8) {
            newSuggestions.push('Password should be at least 8 characters long')
        }
        if (!/\d/.test(input)) {
            newSuggestions.push('Add at least one number')
        }

        if (!/[A-Z]/.test(input) || !/[a-z]/.test(input)) {
            newSuggestions.push('Include both upper and lower case letters')
        }

        if (!/[^A-Za-z0-9]/.test(input)) {
            newSuggestions.push('Include at least one special character')
        }

        setSuggestions(newSuggestions);

        // Determine password strength based on suggestions
        if (newSuggestions.length === 0) {
            setStrength('Very Strong');
            //console.log('Very Strong')
        }
        else if (newSuggestions.length <= 1) {
            setStrength('Strong')
            //console.log('Strong')

        }
        else if (newSuggestions.length <= 2) {
            setStrength('Moderate')
            //console.log('Moderate')

        }
        else if (newSuggestions.length <= 3) {
            setStrength('Weak')
            //console.log('Weak')

        }
        else {
            setStrength('Too Weak')
            //console.log('Too Weak')

        }
    }

    const submitCode_to_db = async () => {

        if (password === '') {
            setIsPasswordFocused(true)
            return
        }
        if (password2 === '') {
            setIsPassword2Focused(true)
            return
        }

        if (strength === '') {
            setErrorMessage('Set a strong password')
            setIsErrorCompVisible(true)
        }

        if (strength !== 'Very Strong') {
            //console.log('Here 1')
            setErrorMessage('Set a strong password')
            setIsErrorCompVisible(true)
            return
        }

        if (password !== password2) {
            //console.log('Here 2')
            setErrorMessage('Make sure both passwords are the same')
            setIsErrorCompVisible(true)

            return
        }

        setIsLoading(true);
        setButtonActive(true)


        try {
            const res = await axios.post('/resetPas/resetPas', { email, resetCode, newPassword: password });
            //console.log('response', res.data.message);

            if (res.status === 200 || res.status === 201) {
                setSuccessMessage(res.data.message)
                setIsSuccessCompVisible(true)
            } else {
                setErrorMessage('password code verification failed')
                setIsErrorCompVisible(true)
            }
        } catch (error) {
            setErrorMessage(error.response.data.error || error.response.data.message || 'Something went wrong, check your password')
            setIsErrorCompVisible(true)
            //console.log(error);
        } finally {
            setIsLoading(false);
        }
    }


    // if (isLoading) {
    //     return (
    //         <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
    //             <ActivityIndicator size={'large'} color={Colours.PRIMARY} />
    //         </View>
    //     )
    // }

    return (
        <View style={styles.createPullFormContainer}>
            <TouchableOpacity
                onPress={hideModal}
                style={styles.backButtonStyle}
            >
                <BackArrow color={Colours.DARKGRAY} />
            </TouchableOpacity>
            <View style={styles.profilePhotoContainer} >
                <PasswordIcon height={dynamicSpacing(40)} width={dynamicSize(40)} color={Colours.PRIMARY} />
            </View>
            {/* <View style={styles.textAndTxtInput}> */}
            <View style={styles.inputContainer}>
                <Text style={styles.label}>PASSWORD</Text>
                <AppTextInput style={[styles.input, isPasswordFocused && styles.focusedBorder,]}
                    placeholder='Password'
                    fontSize={15}
                    secureTextEntry={true}
                    // secureTextEntry={showPassword ? false : true} // Make it a password input
                    onFocus={() => setIsPasswordFocused(true)}
                    onBlur={() => {
                        setIsPasswordFocused(false)
                        // setPasswordError(false)

                    }}
                    onChangeText={handlePassword}
                />

                {suggestions.length > 0 && (
                    <View style={styles.passwordErrorMsg}>
                        <Text style={styles.passwordMsgTxt}>
                            {suggestions.map((suggestion, index) => (
                                <Text key={index}>
                                    {suggestion}
                                    {/* {'\n'} */}
                                </Text>))}
                        </Text>
                    </View>
                )}
                {/* Strength Meter */}
                {strength.length > 0 && (<View style={styles.strengthMeter}>
                    <View style={{
                        width: `${(strength === 'Very Strong' ? 100 :
                            (strength === 'Strong' ? 75 :
                                (strength === 'Moderate' ? 50 :
                                    (strength === 'Weak' ? 25 : 0))))}%`,
                        height: 20,
                        backgroundColor: strength === 'Too Weak' ? 'red' :
                            (strength === 'Weak' ? 'orange' :
                                (strength === 'Moderate' ? 'yellow' :
                                    (strength === 'Strong' ? 'green' : 'limegreen')))
                    }}>
                    </View>
                </View>)}
            </View>
            <View style={styles.inputContainer}>
                <Text style={styles.label}>RE-ENTER PASSWORD</Text>
                <AppTextInput style={[styles.input, isPassword2Focused && styles.focusedBorder,]}
                    placeholder='Password'
                    fontSize={15}
                    secureTextEntry={true}
                    // secureTextEntry={showPassword ? false : true} // Make it a password input
                    onFocus={() => setIsPassword2Focused(true)}
                    onBlur={() => {
                        setIsPassword2Focused(false)
                        // setPasswordError(false)

                    }}
                    onChangeText={handle2Password}
                />
            </View>

            {/* </View> */}
            <TouchableOpacity style={[styles.buttonGray,
            { backgroundColor: buttonActive ? Colours.DARKGRAY : Colours.PRIMARY }]}
                onPress={() => {
                    submitCode_to_db()
                }}
            >
                {isLoading ? (
                    <ActivityIndicator size='small' color='white' />
                ) : (
                    <Text style={{ color: 'white', fontSize: dynamicFontSize(15), fontFamily: 'Sen-Bold' }}>Update</Text>
                )
                }
            </TouchableOpacity>

            <Modal
                visible={isErrorCompVisible}
                transparent={true}
                animationType="fade"
                onRequestClose={() => setIsErrorCompVisible(false)}
            >
                <ErrorAlertComp
                    message={errorMessage}
                    onClose={() => setIsErrorCompVisible(false)}
                />
            </Modal>
            <Modal
                visible={isSuccessCompVisible}
                transparent={true}
                animationType="fade"
                onRequestClose={() => setIsSuccessCompVisible(false)}
            >
                <SuccessAlertComp
                    message={successMessasge}
                    onClose={() => {
                        setIsSuccessCompVisible(false)
                        setNewPasswordSettingsVisible(false)
                        setIsVerifyEmailCodeVisible(false)
                        setShowEmailEntry(false)
                        hideModal()
                    }}
                />
            </Modal>
        </View>
    )
}

const styles = StyleSheet.create({
    createPullFormContainer: {
        flex: 1, // Use flex: 1 to fill the screen
        paddingTop: dynamicSpacing(20),
        padding: dynamicSpacing(15),
        backgroundColor: 'white',
    },
    inputContainer: {
        marginBottom: height * 0.015,
    },
    backButtonStyle: {
        marginBottom: dynamicSize(60),
    },
    textAndTxtInputRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: dynamicSpacing(15),
    },
    textAndTxtInput: {
        marginTop: dynamicSpacing(15),
    },
    textInputStyle: {
        height: dynamicSpacing(50),
        marginTop: dynamicSpacing(10),
        padding: dynamicSpacing(15),
        borderWidth: dynamicSize(1.5),
        borderColor: Colours.DARKLIGHTGRAY,
        borderRadius: dynamicSize(7),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(12),
    },
    focusedBorder: {
        borderColor: Colours.PRIMARY,
    },
    buttonGray: {
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: dynamicSize(15),
        marginTop: dynamicSpacing(25),
        height: dynamicSpacing(60),
    },
    profilePhotoContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: dynamicSpacing(10),
    },
    userImage: {
        width: dynamicSize(100),
        height: dynamicSize(100),
        borderRadius: dynamicSize(99),
        marginBottom: dynamicSpacing(3),
        borderWidth: dynamicSize(1.5),
        borderColor: Colours.PRIMARY,
        marginTop: dynamicSpacing(10),
        backgroundColor: Colours.LIGHTGRAY,
    },
    passwordErrorMsg: {
        padding: dynamicSize(10),
        marginTop: dynamicSize(10),
        borderRadius: dynamicSize(10),
        backgroundColor: Colours.PRIMARY_LIGHTER
    },
    passwordMsgTxt: {
        fontSize: dynamicFontSize(12),
        fontFamily: 'Sen-Regular',
        color: Colours.PRIMARY,

    },
    label: {
        color: Colours.DARKGRAY,
        // fontSize: width * 0.03,
        fontSize: dynamicFontSize(13),
        fontFamily: 'Sen-Regular',
    },
    input: {
        height: height * 0.06,
        borderWidth: 1.5,
        borderColor: Colours.DARKLIGHTGRAY,
        borderRadius: 7,
        fontFamily: 'Sen-Regular',
        paddingHorizontal: width * 0.03,
    },
    strengthMeter: {
        // width: '80%',
        height: dynamicSize(10),
        backgroundColor: Colours.LIGHTGRAY,
        marginTop: dynamicSize(10),
        borderRadius: dynamicSize(10),
        overflow: 'hidden',
    },
});


export default NewPasswordSettings


